import React, {useEffect, useState} from 'react';

import AnimatedLogoComponent from './../common/genericComponents/animatedLogoComponent';
import MultiStateButton from '../common/genericComponents/redesign/multiStateButton/multiStateButton';
import TitleComponentV2 from '../common/genericComponents/redesign/titleComponentV2/titleComponentV2';

import './engageInitiatorComponent.css';
import ResourcePermissionsComponent from '../common/genericComponents/resourcePermissionsComponent';

const EngagerInitiatorComponentRender = ({
  parentRef,
  permissionsStatusesObj,
  closePopUp,
  onPermissionsSuccess,
  ENGAGER_STATES,
  VIDABOO_CONSTANTS,
}) => {
  const [popupTxt, setPopupTxt] = useState('');

  useEffect(() => {
    const popupTxt =
      parentRef.state.engagerState === ENGAGER_STATES.SENT_CALL_REQUEST ||
      parentRef.state.engagerState ===
        ENGAGER_STATES.CALL_REQUEST_RECEIVED_ON_PEER
        ? 'Connecting...'
        : parentRef.state.engagerState === ENGAGER_STATES.PEER_REJECTED
          ? 'Call declined'
          : parentRef.state.engagerState === ENGAGER_STATES.PEER_ACCEPTED
            ? 'Call accepted'
            : parentRef.props.sessionMode ===
                VIDABOO_CONSTANTS.SESSION_MODES.AUDIO_VIDEO
              ? 'Send invite to a videocall'
              : 'Send invite to a screen sharing session';
    setPopupTxt(popupTxt);
  }, [parentRef.state.engagerState]);

  return (
    <>
      {parentRef.state.showPermissionsPopup && (
        <ResourcePermissionsComponent
          permissionsStatusesObj={permissionsStatusesObj}
          closePopUp={closePopUp}
          onPermissionsSuccess={onPermissionsSuccess}
        />
      )}
      <div className="et-engager-request-popup-wrap">
        <div className="et-erp-content-wrap">
          <div className="et-erp-status-txt">
            <TitleComponentV2 titleTxt={popupTxt} />
          </div>

          {(parentRef.state.engagerState === ENGAGER_STATES.SENT_CALL_REQUEST ||
            parentRef.state.engagerState ===
              ENGAGER_STATES.CALL_REQUEST_RECEIVED_ON_PEER) && (
            <div className="et-erp-logo-wrap">
              <AnimatedLogoComponent eyeClass="et-ovc-pc-eyes-orange" />
            </div>
          )}

          {parentRef.state.engagerState === ENGAGER_STATES.INIT && (
            <div className="et-erp-btns-wrap">
              <div className="et-erp-btn-wrap">
                <MultiStateButton
                  btnTxt="Cancel"
                  onClick={parentRef.closePopup}
                />
              </div>
              <div className="et-erp-btn-wrap">
                <MultiStateButton
                  isPrimaryBtn
                  btnTxt="Send"
                  onClick={parentRef.sendInteractionRequest}
                />
              </div>
            </div>
          )}
        </div>
        <div className="et-erp-bottom-arrow" />
      </div>
    </>
  );
};

export default EngagerInitiatorComponentRender;
